<template>
  <!-- 新闻普通列表 -->
  <div id="app-list">
    <div class="list-box">
      <ul>
        <li v-for="(item,index) in listData.data" :key="index" @click="goDetail(item.id)">
          <p>
            <span class="yuandian"></span>
            {{item.news_title}}
          </p>
          <span>{{item.custom_time}}</span>
        </li>
      </ul>
      <div class="page-box" v-if="listData.total > $db.config.newsListSize2">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="listData.current_page"
          :page-size="$db.config.newsListSize2"
          :total="listData.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["chid", "type"],
  data() {
    return {
      listData: []
    };
  },
  methods: {
    getList(page) {
      //获取列表信息
      this.$db
        .post(this.$db.config.getDataByChidUrl, {
          id: this.chid,
          page_size: this.$db.config.newsListSize2,
          page: page
        })
        .then(res => {
          this.listData = res.data;
        });
    },
    goDetail(id) {
      if (this.type && this.type == 3) {
        //项目新闻
        this.$router.push({
          name: "projectDetails",
          query: { id: id, cid: this.$route.query.cid }
        });
      } else {
        this.$router.push({
          name: "pubDetails",
          query: { id: id, cid: this.$route.query.cid }
        });
      }
    },
    //改变页码
    handleCurrentChange(val) {
      this.getList(val);
    }
  },
  watch: {
    chid: function(val) {
      this.getList(1);
    },
  },
  created() {
    this.getList(1);
  }
};
</script>

<style lang="scss" scoped>
#app-list {
  width: 100%;
}
.list-box {
  width: 1300px;
  margin: 0 auto;
  > ul {
    margin: 40px 0 60px 0;
    > li {
      display: flex;
      justify-content: space-between;
      padding: 22px 40px 22px 26px;
      transition: ease-out 0.6s;
      cursor: pointer;
      &:hover {
        background-color: #c30d23;
        > p {
          color: #fff;
          > .yuandian {
            display: inline-block;
            width: 8px;
            height: 8px;
            background-color: #fff;
            border-radius: 50%;
          }
        }
        > span {
          color: #fff;
        }
      }
      > p {
        font-size: 16px;
        color: #333333;
        width: 65%;
        > .yuandian {
          display: inline-block;
          width: 8px;
          height: 8px;
          background-color: #000;
          border-radius: 50%;
          margin-right: 5px;
          margin-bottom: 1.5px;
        }
      }
      > span {
        font-size: 16px;
        color: #999999;
        width: 25%;
        text-align: right;
      }
    }
  }
  .page-box {
    text-align: center;
    margin-bottom: 70px;
  }
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #c30d23;
  color: #fff;
}
.page-box /deep/ .el-pagination.is-background .el-pager li {
  background-color: #fff;
  border: solid 1px #dddddd;
  color: #999;
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled):hover {
  color: #c30d23;
}
</style>



// WEBPACK FOOTER //
// src/components/Public/public_list.vue